import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadVideoZoom: -1,
    updateRoom: -1,
    ongoing: -1,
  },
  ongoing: null,
  zoomInfo: null,
  videoConsultId: null,
  consultId: null,
  conversationId: null,
  virtualBackgrounds: [],
  patient: null,
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, error } = action;
  switch (type) {
    case ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadVideoZoom: 0,
        },
      };
    case ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadVideoZoom: 1,
        },
        zoomInfo: payload.data,
      };
    case ACTION_TYPES.CONSULT_GET_VIDEO_ROOM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadVideoZoom: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULT_END_VIDEO_ROOM_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updateRoom: 0,
        },
      };
    case ACTION_TYPES.CONSULT_END_VIDEO_ROOM_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          updateRoom: 1,
        },
        zoomInfo: null,
      };
    case ACTION_TYPES.CONSULT_END_VIDEO_ROOM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updateRoom: 2,
        },
        error,
      };

    case ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          closeAllRoom: 0,
        },
      };
    case ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          closeAllRoom: 1,
        },
        zoomInfo: null,
      };
    case ACTION_TYPES.CONSULT_CLOSE_ALL_VIDEO_ROOM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          closeAllRoom: 2,
        },
        error,
      };

    case ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          virtualBackground: 0,
        },
      };
    case ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_SUCCEED:
      return {
        ...state,
        virtualBackgrounds: payload.data,
        status: {
          ...state.status,
          virtualBackground: 1,
        },
      };
    case ACTION_TYPES.ZOOM_VIRTUAL_BACKGROUND_LIST_FAILED:
      return {
        ...state,
        virtualBackgrounds: [],
        status: {
          ...state.status,
          virtualBackground: 2,
        },
      };

    case ACTION_TYPES.CONSULT_GET_ONGOING_CALL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          ongoing: 0,
        },
      };
    case ACTION_TYPES.CONSULT_GET_ONGOING_CALL_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          ongoing: 1,
        },
        ongoing: payload.data,
      };
    case ACTION_TYPES.CONSULT_GET_ONGOING_CALL_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          ongoing: 2,
        },
        error,
      };
    case ACTION_TYPES.VIDEO_TRIGGER_OPEN:
      return {
        ...state,
        videoConsultId: payload.consultId,
        conversationId: payload.conversationId,
        patient: payload.patient,
      };
    case ACTION_TYPES.VIDEO_TRIGGER_CLOSE:
      return initialState;
    default:
      return state;
  }
}
